import { useAuth } from "../contexts/useAuth";

const InvalidToken = () => {
    const { messageErrorTokenLogin } = useAuth();
    return (
        <div className="errorToken">
            <h1>ERROR DE VERIFICACIÓN DE TOKEN</h1>
            <h2>{messageErrorTokenLogin || "MENSAJE DE ERROR DE VERIFICACIÓN DE TOKEN"}</h2>
        </div>
    );
};

export default InvalidToken;
